module.exports = __webpack_public_path__ + "static/media/export_to_pdf.91485645.svg";